import React from "react";
import ImageWrapper from "../ImageComponent/ImageWrapper";

const InputTextAreaComponent = ({ data, onInputChange, value }) => {
  const { placeholder, required, label, image } = data;

  return (
    <fieldset className="border border-light-grey-color w-full rounded-md">
      <legend className="mx-3 px-1 text-xs">
        {label}
        {required ? "*" : ""}
      </legend>
      <div className="flex flex-row justify-start items-start h-20 px-4">
        <div className="relative w-4 h-4 my-0.5">
          <ImageWrapper
            src={image ? image : "/icons/Profile_Red.svg"}
            alt="d"
          />
        </div>
        <textarea
          name={data.inputKey}
          value={value}
          onChange={onInputChange}
          placeholder={placeholder}
          className={`w-full h-full border-0 placeholder:text-[#47556980] bg-transparent focus:outline-none placeholder:text-PH_Default placeholder:text-sm rounded-md pl-2`}
          style={{
            height: "70px",
            resize: "none",
            overflowY: "auto",
          }}
        />
      </div>
    </fieldset>
  );
};

export default InputTextAreaComponent;
